module.exports = __webpack_public_path__ + "media/images/icon-svg/cart-2-5abfc59c2996f02f84ae7ecdd35217ad.svg";